module.exports = __webpack_public_path__ + "img/bg.130b877c.png";